<div class="toastr-container">
    <!--
        TODO (Future Proofed Component):
        When this component is finally in active use, 
        ensure to acquire the appropriate icon from the UI/UX designer.
    -->
    <img
        src="/assets/images/toastr/toastr-info.png"
        alt="Success"
        class="toastr-icon"
    />
    <span class="toastr-message" [innerHTML]="message">
    </span>
    <button
        class="toastr-dismiss"
        (click)="closeToast()"
        [attr.aria-label]="'text.dismiss' | translate"
    >
        <img
            src="/assets/images/cross_white.svg"
            alt=""
            class="toastr-dismiss-icon"
        />
    </button>
</div>